<template>
  <div>
    <table class="Container" :key="index" v-for="(plant, index) in plants">
      <tr>
        <td class="BatchDetail">
          <p style="display: flex;">
            <b>Strain Name:</b>&nbsp;
            <span class="BatchName">{{ plant.plant_name }}</span>
          </p>
          <p>
            <b>Serial Number :</b>
            {{ plant.serialNumber }}
          </p>
          <p>
            <b>Batch Number :</b>
            {{ plant.batch && plant.batch.batch_number }}
          </p>
          <p>
            <b>Start Date :</b>
            {{ date }}
          </p>
        </td>
        <td>
          <bar-code :options="options" :value="plant.serialNumber" />
          <bar-code :options="options" :value="plant.batch && plant.batch.batch_number" />
        </td>
      </tr>
    </table>

    <div v-html="html" />
  </div>
</template>

<script>
import Vue from 'vue'
import LoadScript from 'vue-plugin-load-script'
import BarCode from '@/components/utils/BarCode.vue'

Vue.use(LoadScript)

export default {
  name: 'ThermalPlants',

  props: ['plants', 'date'],

  components: {
    BarCode
  },

  data: () => ({
    options: {
      width: 4,
      height: 250
    },
    html: `
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">
    <link href="https://fonts.googleapis.com/css?family=Libre+Barcode+39&display=swap" rel="stylesheet">
    <style>
      .Container {
        transform: rotate(270deg);
        margin-top: 45%;
        margin-left: -34%;
        page-break-after: always;
      }

      .BatchDetail {
        font-size: 60px;
        white-space: nowrap;    
        padding: 40px;
        padding-top: 0px;
      }

      .BatchDetail p {
        padding: 0px;
        margin: 0px;
      }

      .BatchName {
        max-width: 640px;
        line-height: 1;
        word-break: break-all;
        white-space: pre-wrap;
      }
    </style>`
  }),

  mounted() {
    this.$loadScript('https://code.jquery.com/jquery-3.3.1.slim.min.js')
      .then(() => {
        this.$loadScript('https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js')
          .then(() => {
            this.$loadScript('https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js')
          })
          .catch(() => {})
      })
      .catch(() => {})
  }
}
</script>
